export default class Menu {

	constructor()
	{
		Menu.burger();
		Menu.lang();
	}

	static burger()
	{
		const trigger     = '[data-trigger="wpiris-menu-toggle"]',
			$element    = $( '[data-id="wpiris-menu"]' ),
			element_item = '[data-item="submenu"]',
			trigger_more = '[data-trigger="wpiris-menu-more"]',
			trigger_back = '[data-trigger="wpiris-menu-back"]';

		$( document ).on( 'click', trigger, function ( e ) {
			e.preventDefault();

			$element.toggleClass( 'is-open' );
			$( trigger ).toggleClass( 'is-open' );
			$( 'body' ).toggleClass( 'menu-open' );
			$( element_item ).removeClass( 'submenu--active' );
		} );

		$( document ).on( 'click', trigger_more, function ( e ) {
			$( element_item ).removeClass( 'submenu--active' );
			$( this ).closest('[data-id="wpiris-menu-item"]').find(element_item).addClass( 'submenu--active' );
		} );

		$( document ).on( 'click', trigger_back, function ( e ) {
			$( this ).parents( element_item ).removeClass( 'submenu--active' );
		} );
	}

	static lang() {
		const trigger = '[data-id="wpiris_current-lang"]',
			  list = '[data-id="wpiris_lang-list"]';

		$(trigger).on('click', function () {
			$(list).toggleClass('lang--open');
		})
	}
}
